import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiEndpoints } from 'Utils/ApiEndpoints';

const baseUrl = process.env.REACT_APP_BASE_URL
const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth?.authData?.token;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })(args, api, extraOptions);

    if (result?.error && result?.error.status === 401) {
        // window.location.href = '/'
    }
    return result;
};

export const userApi = createApi({
    reducerPath: 'userApi',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['User'],
    endpoints: (builder) => ({
        getUserData: builder.query({
            query: ({ page, limit, searchData }) => ({
                url: `${apiEndpoints?.userGetUrl}?page=${page}&limit=${limit}&search_key=${searchData ?? ''}`,
                method: 'GET',
            }),
            providesTags: ['User'],
        }),
        getUserDataDetails: builder.query({
            query: (userId) => ({
                url: `${apiEndpoints?.userDetailsUrl}?user_id=${userId}`,
                method: 'GET',
            }),
            providesTags: ['User'],
        }),
        updateUserStatus: builder.mutation({
            query: (data) => ({
                url: apiEndpoints?.userStatusUrl,
                method: "PUT",
                body: data
            }),
            invalidatesTags: ['User'],
        }),
        getDashboardData: builder.query({
            query: ({ id }) => ({
                url: `${apiEndpoints?.userDashboardUrl}?user_id=${id}`,
                method: 'GET',
            }),
            providesTags: ['User'],
        }),
        actionList: builder.query({
            query: ({ id }) => ({
                url: `${apiEndpoints?.userActionUrl}`,
                method: 'GET',
            }),
            providesTags: ['User'],
        }),
        updateActionDetails: builder.mutation({
            query: (payload) => ({
                url: apiEndpoints?.updateDropdownActionUrl,
                method: "PUT",
                body: payload
            }),
            invalidatesTags: ['User'],
        }),
        updateUserAllowScreen: builder.mutation({
            query: (payload) => ({
                url: apiEndpoints?.updateUserAllowScreenUrl,
                method: "PUT",
                body: payload
            }),
            invalidatesTags: ['User'],
        }),
        actionMessageList: builder.query({
            query: ({ user_id, type, startDate, endDate }) => {
                if (!type || !user_id) {
                    return null;
                } else if (!startDate || !endDate) {
                    return {
                        url: `${apiEndpoints?.userActionMessageUrl}?userId=${user_id}&type=${type}`,
                        method: 'GET'
                    }
                } else {
                    return {
                        url: `${apiEndpoints?.userActionMessageUrl}?userId=${user_id}&type=${type}&startDate=${startDate}&endDate=${endDate}`,
                        method: 'GET'
                    }
                }
            },
            providesTags: ['User'],
        }),
        getDeptList: builder.query({
            query: ({ divisionId }) => {
                if (!divisionId) {
                    return null;
                } else {
                    return {
                        url: `${apiEndpoints?.getDeptListUrl}?divisionId=${divisionId}`,
                        method: 'GET'
                    }
                }
            },
            providesTags: ['Company']
        }),
        getHCListByType: builder.query({
            query: ({ type }) => {
                if (!type) return null;
                return {
                    url: `${apiEndpoints?.getCommonHCList}?type=${type}`,
                    method: 'GET'
                }
            },
            providesTags: ['Company']
        }),
    })
});

export const {
    useGetUserDataQuery,
    useGetUserDataDetailsQuery,
    useUpdateUserStatusMutation,
    useGetDashboardDataQuery,
    useActionListQuery,
    useActionMessageListQuery,
    useUpdateActionDetailsMutation,
    useUpdateUserAllowScreenMutation,
    useGetDeptListQuery,
    useGetHCListByTypeQuery
} = userApi;
